import { apiConstants } from "../../config";
import {
  apiPost,
  apiPut,
  apiGet,
  apiDelete
} from "../../../../shared/services";

const fetchItems = async (options, cancelToken) => {
  const url = apiConstants.url;
  return await apiGet(url, { params: options, cancelToken });
};

const saveItem = async (id, data, validator) => {
  if (id) {
    let url = apiConstants.url + "/" + id;
    return await apiPut(url, { ...data }, validator);
  } else {
    let url = apiConstants.url;
    return await apiPost(url, { ...data }, validator);
  }
};

const fetchItem = async id => {
  const url = apiConstants.url;
  return await apiGet(url + "/" + id);
};

const deleteItem = async id => {
  const url = apiConstants.url;
  return await apiDelete(url + "/" + id);
};

const submitOrder = async (id, data, validator) => {
  const url = apiConstants.url;
  return await apiPost(url + "/" + id, { ...data }, validator);
};

const confirmOrder = async (id, data, validator) => {
  const url = apiConstants.url;
  return await apiPost(url + "/" + id + "/confirm", { ...data }, validator);
};

const declineOrder = async (id, data, validator) => {
  const url = apiConstants.url;
  return await apiPost(url + "/" + id + "/decline", { ...data }, validator);
};

const savePayment = async (id, data, validator) => {
  const url = apiConstants.url;
  return await apiPost(url + "/" + id + "/savepayment", { ...data }, validator);
};

const setPayedAmount = async (id, data, validator) => {
  const url = apiConstants.url;
  return await apiPost(
    url + "/" + id + "/setpayedamount",
    { ...data },
    validator
  );
};

const setOrderSend = async (id, data, validator) => {
  const url = apiConstants.url;
  return await apiPost(
    url + "/" + id + "/setordersend",
    { ...data },
    validator
  );
};

const regenerateDocument = async (id, data, validator) => {
  const url = apiConstants.orderDocument;
  return await apiPost(url + "/" + id + "/regenerate", { ...data }, validator);
};

const generateDeliveryNote = async (id, data, validator) => {
  const url = apiConstants.url;
  return await apiPost(
    url + "/" + id + "/generatedeliverynote",
    { ...data },
    validator
  );
};

const setDocumentInternal = async (id, data, validator) => {
  const url = apiConstants.orderDocument;
  return await apiPost(url + "/" + id + "/setinternal", { ...data }, validator);
};

const fetchTags = async options => {
  const url = apiConstants.tags;
  return await apiGet(url, { params: options });
};

const fetchOrderItems = async id => {
  const url = apiConstants.url + "/" + id + "/items";
  return await apiGet(url);
};

export {
  fetchItems,
  saveItem,
  deleteItem,
  fetchItem,
  submitOrder,
  fetchTags,
  fetchOrderItems,
  confirmOrder,
  declineOrder,
  savePayment,
  setPayedAmount,
  setOrderSend,
  regenerateDocument,
  generateDeliveryNote,
  setDocumentInternal
};
